// @flow
'use strict';
import React from 'react';

export default function VersionInfo(props: { fromYear: number, version: string }) {
    const pStyle = {
        textAlign: 'center',
        fontSize: '0.75em',
        color: '#aaa',
        fontWeight: '300'
    };
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    return (
        <p style={pStyle}>
            {`version ${props.version}`}
            <br />
            {`© ${props.fromYear}${props.fromYear < currentYear
                ? `-${currentYear}`
                : ''} Small Business Innovations, Inc.`}
        </p>
    );
}



// WEBPACK FOOTER //
// ./components/atoms/VersionInfo.jsx